  import $ from 'jquery';
  import { getQueryVariable } from './querystring';
 
  
  /*Building Concepts Learning Sequences*/
  function createCookie(name, value, days) {
  	if (days) {
  		var date = new Date();
  		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  		var expires = "; expires=" + date.toUTCString();
  	} else var expires = "";
  	document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
  	var nameEQ = name + "=";
  	var ca = document.cookie.split(';');
  	for (var i = 0; i < ca.length; i++) {
  		var c = ca[i];
  		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
  		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  	}
  	return null;
  }

  function eraseCookie(name) {
  	createCookie(name, "", -1);
  }

  var conceptsFiltering = $(".learning-sequences.concepts .learning-sequences-select");
  var conceptsFilterSelect = conceptsFiltering.find("#select-topic");
  var conceptsFilter2Select = conceptsFiltering.find("#select-grade");
  var conceptsFilter3Select = conceptsFiltering.find("#select-standard");

  conceptsFilterSelect.change(function() {
  	var filter = $(this).val();
  	var url = document.location.origin;
  	var newURL = url + filter;
  	window.location.href = newURL;

  });
  conceptsFilter2Select.change(function() {
  	var filter = $(this).val();
  	var cards = $('.learning-sequences-results .card');
  	if (filter == "reset") {
  		cards.each(function(i) {
  			$(this).fadeIn("fast");
  		});
  	} else {
  		$('.activity-category').hide();
  		cards.fadeOut("fast");
  		var gradeCards = $('.learning-sequences-results .card[data-grade-levels*="' + filter + '"]');
  		if (gradeCards.length > 0) {
  			$('.learning-sequences-results .card[data-grade-levels*="' + filter + '"]').each(function(i) {
  				$(this).fadeIn("fast");
  			});
  			$('.no-results').hide();
  		} else {
  			$('.no-results').show();
  		}

  	}
  });
  conceptsFilter3Select.change(function() {
  	var filter = String($(this).val()).toLowerCase();

  	if (filter == "reset") {

  		$('.learning-sequences-results .card .standards').each(function(i) {
  			$(this).fadeOut("fast");
  		});
  		eraseCookie('standard');

  	} else {
  		$('.learning-sequences-results .card .standards').each(function(i) {
  			$(this).fadeOut("fast");
  			if ($(this).hasClass(filter)) {
  				$(this).fadeIn("fast");
  				createCookie('standard', filter, 7);
  			}
  		});
  	}

  });
  /*France*/
  function FranceFilter() {
  	var filterestablishment = $('.learning-sequences-select #select-establishment').val();
  	var filterlevel = $('.learning-sequences-select #select-level').val();
  	var filtertheme = $('.learning-sequences-select #select-theme').val();
  	var cards = $('.learning-sequences-results .card');
  	// console.log(filterestablishment, filterlevel, filtertheme );

  	if (filterestablishment == "reset" && filterlevel == "reset" && filtertheme == "reset") {
  		cards.fadeOut("fast");
  		$('.learning-sequences .activity-category').show();
  	} else {
  		cards.fadeOut("fast");
  		$('.learning-sequences .activity-category').hide();
  		$('.france.no-results').hide();

  		if (filterestablishment != "reset") {
  			var establishment = '[data-establishment*="' + filterestablishment + '"]';
  		} else {
  			var establishment = "";
  		}
  		if (filterlevel != "reset") {
  			var level = '[data-level*="' + filterlevel + '"]';
  		} else {
  			var level = "";
  		}
  		if (filtertheme != "reset") {
  			var theme = '[data-theme*="' + filtertheme + '"]';
  		} else {
  			var theme = "";
  		}
  		var num = 0;
  		$('.learning-sequences-results .card' + establishment + level + theme + '').each(function(i) {
  			$(this).fadeIn("fast");
  			num++;
  		});
  		// console.log(num);
  		// console.log(filterestablishment, filterlevel, filtertheme );
  		if (num == 0) {
  			$('.france.no-results').show();
  		}
  	}
  }
  $('.learning-sequences.france .learning-sequences-select select').on('change', function(value) {
  	FranceFilter();
  });
  $('.learning-sequences.france .activity-category a').on('click', function(this: HTMLAnchorElement, value) {
  	$('.learning-sequences .activity-category').hide();
  	var key = getQueryVariable("q", this.href);
	if(key) {
  		$('#select-theme').val(key).trigger("change");
	}

  	return false;

  });
  /*Portuguese Activities*/
  var $portugalFilterParent = $('.learning-sequences.portugal .learning-sequences-select');
  //First Filter
  var $portugalFilterSelect = $portugalFilterParent.find("#select-level");
  //Second Filter
  var $portugalFilter2Select = $portugalFilterParent.find("#select-discipline");
  var $portugalFilter2SelectOptions = $portugalFilter2Select.find("option");
  var $portugalFilter2Reset = $portugalFilter2Select.find("option:first-child");
  //Third Filter
  var $portugalFilter3Select = $portugalFilterParent.find("#select-topic");
  var $portugalFilter3SelectOptions = $portugalFilter3Select.find("option");
  var $portugalFilter3Reset = $portugalFilter3Select.find("option:first-child");
  var activityCategory = $('.learning-sequences .activity-category');
  var noresults = $('.no-results');

  function PortugalFilter() {
  	var filter1 = $portugalFilterSelect.val();
  	var filter2 = $portugalFilter2Select.val();
  	var filter3 = $portugalFilter3Select.val();
  	var cards = $('.learning-sequences-results .card');

  	// console.log(filter1, filter2, filter3);

  	if (filter1 == "reset" && filter2 == "reset" && filter3 == "reset") {
  		cards.fadeOut("fast");
  		activityCategory.show();
  	} else {
  		cards.fadeOut("fast");
  		activityCategory.hide();
  		noresults.hide();

  		if (filter1 != "reset") {
  			var level = '[data-level*="' + filter1 + '"]';
  		} else {
  			var level = "";
  		}
  		if (filter2 != "reset") {
  			var discipline = '[data-discipline*="' + filter2 + '"]';
  		} else {
  			var discipline = "";
  		}
  		if (filter3 != "reset") {
  			var topic = '[data-topic*="' + filter3 + '"]';
  		} else {
  			var topic = "";
  		}

  		var $cardEl = $('.learning-sequences-results .card' + level + discipline + topic + '');
  		if ($cardEl.length > 0) {
  			$cardEl.each(function(i) {
  				$(this).fadeIn("fast");
  			});
  		} else {
  			noresults.show();
  		}

  	}
  }
  //Link on activity cards
  $('.learning-sequences.portugal .activity-category a').on('click', function(this: HTMLAnchorElement, value) {
  	var key = getQueryVariable("q", this.href);
	if(key) {
  		$('#select-level').val(key).trigger("change");
	}
  	return false;

  });
  //First filter onchange
  $portugalFilterSelect.on('change', function() {
  	var value = $(this).val();

  	$portugalFilter2SelectOptions.fadeOut("fast");
  	if (value == "reset") {
  		$portugalFilter2SelectOptions.fadeIn("fast");
  		activityCategory.show();
  		$portugalFilter2Select.val("reset").trigger("change");
  		$portugalFilter2Select.prop('disabled', true);
  		$portugalFilter3Select.val("reset").trigger("change");
  		$portugalFilter3Select.prop('disabled', true);
  	} else {
  		$portugalFilter2Select.prop('disabled', false);

  		$portugalFilter2Select.find('option[data-level*="' + value + '"]').each(function() {
  			$(this).fadeIn("fast");
  		});
  		$portugalFilter2Reset.fadeIn("fast");
  		PortugalFilter();
  	}
  });
  //Second filter onchange
  $portugalFilter2Select.on('change', function() {
  	var value = $(this).val();
  	$portugalFilter3SelectOptions.fadeOut("fast");
  	if (value == "reset") {
  		$portugalFilter3SelectOptions.fadeIn("fast");
  		$portugalFilter3Select.val("reset").trigger("change");
  		$portugalFilter3Select.prop('disabled', true);
  		// PortugalFilter(value);
  	} else {
  		$portugalFilter3Select.prop('disabled', false);
  		$portugalFilter3Select.find('option[data-discipline*="' + value + '"]').each(function() {
  			$(this).fadeIn("fast");
  		});
  		$portugalFilter3Reset.fadeIn("fast").attr('selected');
  		PortugalFilter();
  	}
  });
  //Third filter onchange
  $portugalFilter3Select.on('change', function() {
  	var value = $(this).val();
  	if (value == "reset") {
  		$portugalFilter3SelectOptions.fadeIn("fast");
  		PortugalFilter();
  	} else {
  		$portugalFilter3Select.prop('disabled', false);
  		$portugalFilter3Select.find('option[data-discipline*="' + value + '"]').each(function() {
  			$(this).fadeIn("fast");
  		});
  		$portugalFilter3Reset.fadeIn("fast").attr('selected');
  		PortugalFilter();
  	}
  });

$(function(){
     //Check for cookie if standards divs exist 
  if ($('.contentblock.view-standard').length) {
    var standardCookie = readCookie('standard');
    var defaultStandards = $('.standards.docs');
    var ccssStandards = $('ul.standards.ccss');
    var teksStandards = $('ul.standards.teks');
    // console.log(standardCookie);
    if (standardCookie == "ccss") {
      defaultStandards.hide();
      teksStandards.hide();
      ccssStandards.show();
    } else if (standardCookie == "teks") {
      defaultStandards.hide();
      teksStandards.show();
      ccssStandards.hide();
    } else {
      defaultStandards.show();
      teksStandards.hide();
      ccssStandards.hide();
    }
  }

  //Hide cards 
  if ($('.learning-sequences.france, .learning-sequences.portugal').length) {
    $('.learning-sequences-results .card').fadeOut("fast");
    $('.no-results').hide();
  }
  if ($('.learning-sequences.concepts').length) {
    $('.no-results').hide();
    if ($("#select-topic").val() == "/building-concepts/activities" && $("#select-grade, #select-standard").val() == "reset") {
      $('.learning-sequences-results .card').fadeOut("fast");
      $('.activity-category').show();
    } else {
      $('.learning-sequences-results .card').fadeIn("fast");
      $('.activity-category').hide();
    }
  }
});

